export const handleShare = async (articleUrl, title, summary) => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: title,
        text: summary,
        url: articleUrl,
      });
    } catch (error) {
      console.error("Error sharing:", error);
    }
  } else {
    alert("Web Share API is not supported in this browser.");
  }
};

export const handleSharePicture = async (imageUrl) => {
  if (navigator.share) {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const filesArray = [
        new File([blob], "card.png", {
          type: blob.type,
        }),
      ];

      await navigator.share({
        files: filesArray,
      });
    } catch (error) {
      console.error("Error sharing:", error);
    }
  } else {
    alert("Web Share API is not supported in this browser.");
  }
};

// Share on Facebook
// export const handleFacebookShare = (imageUrl) => {
//   const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
//     imageUrl
//   )}`;
//   window.open(facebookShareUrl, "_blank", "noopener,noreferrer");
// };
export const handleFacebookShare = (imageUrl) => {
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    imageUrl
  )}`;
  window.open(facebookShareUrl, "_blank", "noopener,noreferrer");
};
